export default __webpack_public_path__ + "static/media/H0006.59145f79.png";